import React from 'react';

const AdobeIllustratorIcon = ({ classes }) => (
  <svg className={classes} role="img" viewBox="0 0 455 455">
    <g>
      <path
        d="M186.199,153.546c-3.542,14.264-25.092,96.545-25.092,96.545h52.75
		c0,0-23.461-82.281-26.966-96.545H186.199z"
      />
      <path
        d="M0,0v455h455V0H0z M240.023,351.601l-18.428-61.115h-68.192l-17.074,61.115
		H80.455l72.949-238.312h70.621l73.885,238.312H240.023z M372.774,351.601H318.95V178.775h53.824V351.601z M345.533,157.503
		c-16.935,0-28.317-12.078-27.936-26.86c-0.381-15.583,11.002-27.244,28.353-27.244c17.352,0,28.18,11.66,28.595,27.244
		C374.545,145.425,363.302,157.503,345.533,157.503z"
      />
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export default AdobeIllustratorIcon;
